export default __webpack_public_path__ + "static/google-b2ec2f46c989497bc84516ee1998d901.svg";